import store from 'src/js/store';
import actions from '../actions';

function setActiveTool(id) {
  store.dispatch(actions.setActiveTool(id));
}

export default setActiveTool;
